import React from 'react';

import { usePrefetchMinfest } from '../../page/components/page-prefetch';
import useCartState from '../../hooks/useCartState';

const PrefetchContainer = () => {
    usePrefetchMinfest('cart', true);
    return null;
};

export default ({}) => {
    const { emptyCart = true } = useCartState();

    if (emptyCart) {
        return null;
    }
    return <PrefetchContainer />;
};
